import { AudioOutput } from "./audio-output.mjs";
import { createScope } from "@proj-airi/pipelines-audio";
//#region src/browser/media-stream.ts
/**
* Plays PCM into a new MediaStream for APIs that only accept tracks, such as Web Speech recognition.
*
* `done` resolves after the PCM stream ends and its audio has played. Aborting `signal` stops output
* immediately. The returned tracks belong to this call and stop when it settles.
*/
function toMediaStream(frames, context, signal) {
	const scope = createScope(signal);
	const destination = context.createMediaStreamDestination();
	const output = new AudioOutput(context, frames, destination);
	scope.defer(() => output.stop({ fadeMs: 0 }).catch(() => {}));
	const done = output.done.then(() => scope.signal.throwIfAborted()).finally(() => {
		scope.close("Media stream output ended");
		destination.disconnect();
		destination.stream.getTracks().forEach((track) => track.stop());
	});
	return {
		media: destination.stream,
		done
	};
}
//#endregion
export { toMediaStream };
